import * as React from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BuildIcon from '@mui/icons-material/Build';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

import { SalesCoordinatorNewInstallation } from './SalesCoordinatorNewInstallation';
import { SalesCoordinatorRemovalTransfer } from './SalesCoordinatorRemovalTransfer';
import { SalesCoordinatorRepairReplacement } from './SalesCoordinatorRepairReplacement';

const TABS = [
  { label: 'New Installation',     icon: <BuildIcon fontSize="small" />,              component: SalesCoordinatorNewInstallation },
  { label: 'Removal / Transfer',   icon: <SwapHorizIcon fontSize="small" />,          component: SalesCoordinatorRemovalTransfer },
  { label: 'Repair / Replacement', icon: <AssignmentTurnedInIcon fontSize="small" />, component: SalesCoordinatorRepairReplacement },
];

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function CollectionRecoveryPage() {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ px: 3, pt: 3, pb: 1, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <SupervisorAccountIcon sx={{ fontSize: 32, color: 'primary.main' }} />
        <Typography variant="h5" fontWeight={600}>Collection Recovery</Typography>
      </Box>

      <Paper elevation={0} sx={{ mx: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            px: 1,
            '& .MuiTab-root': { minHeight: 52, textTransform: 'none', fontWeight: 500, fontSize: '0.9rem', gap: 0.75 },
            '& .Mui-selected': { fontWeight: 700 },
          }}
        >
          {TABS.map((tab, i) => (
            <Tab key={i} label={tab.label} icon={tab.icon} iconPosition="start" />
          ))}
        </Tabs>
      </Paper>

      {TABS.map((tab, i) => (
        <TabPanel key={i} value={activeTab} index={i}>
          <tab.component />
        </TabPanel>
      ))}
    </Box>
  );
}
